
import { Component, Vue } from 'vue-property-decorator';

import Form19ProcessHeader from "@/components/process/Form19/components/Form19ProcessHeader.vue";
import Form19CaseInformation from "@/components/process/Form19/components/Form19CaseInformation.vue";
import { form19StatusInfoType } from '@/types/Information/Form19';

@Component({
    components:{
        Form19ProcessHeader,
        Form19CaseInformation
    }
})
export default class StartForm19 extends Vue {

    stepsCompleted = {} as form19StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
